import { ClaimScoreApiVersion } from '../types';
import { getClientForVersion } from '../utils';
import { TriggerCaseSyncPayload, TriggerCaseSyncResponse } from './types';

export const triggerCaseSync = async (
  payload: TriggerCaseSyncPayload,
): Promise<TriggerCaseSyncResponse> => {
  const client = getClientForVersion(ClaimScoreApiVersion.V2);
  const { data } = await client.post('/sync/clickhouse', payload);
  return data;
};
